<div class="modal-header">
  <h3 class="modal-title">
    <strong>Apply Defaults</strong>
  </h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise = !minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">
  <div class="divShadow">
    @if (loading) {
<div class="formLoader">
      <i class="fa fa-spinner fa-spin gt-refresh"></i>
    </div>
}

    @if (!loading) {
<div>
      <div class="table-container">
        <div class="divShadow">
          <div class="table-responsive">
            <table class="table table-hover table-bordered table-striped table-condensed">
              <thead>
                <tr>
                  <th></th>
                  <th>Warning</th>
                  <th>LEID</th>
                  <th>Tax Code</th>
                  <th>ME Code</th>
                  <th>Reporting Period</th>
                  <th>BR Tax LEID</th>
                  <th>Country</th>
                  <th>Basket</th>
                  <th>BR Tax TB Amt</th>
                  <th>Credit BR Tax Amt</th>
                  <th>Applicable Year</th>
                </tr>
              </thead>
              <tbody>
                @for (t of defaultsMultipleSelected; track $index) {
<tr>
                  <td>
                    <i class="fa fa-times" style="cursor: pointer;"
                       (click)="removeDefaultsRow(t)"
                       title="Remove Row"></i>
                  </td>
                  <td [ngClass]="t.BACKGROUND_COLOR">{{ t.STATUS_TEXT }}</td>
                  <td>{{ t.LEID }}</td>
                  <td>{{ t.CDR_NO }}</td>
                  <td>{{ t.ME_CODE }}</td>
                  <td>{{ t.REPORTING_PERIOD }}</td>
                  <td>{{ t.LEID }}</td>
                  <td>{{ t.LE_COUNTRY_NAME }}</td>
                  <td>{{ t.BASKET }}</td>
                  <td [ngClass]="{'color-red': t.TB_AMT < 0}">{{ formatNumber(t.TB_AMT) }}</td>
                  <td [ngClass]="{'color-red': t.CREDIT_AMT < 0}">{{ formatNumber(t.CREDIT_AMT) }}</td>
                  <td>{{ t.CURRENT_TAX_YEAR }}</td>
                </tr>
}
                @if (defaultsMultipleSelected.length === 0) {
<tr>
                  <td colspan="12" style="text-align: center;">No rows selected</td>
                </tr>
}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-info btn-sm" type="button"
                (click)="save()" [disabled]="isSaveClicked">
          @if (isSaveClicked) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
        </button>
        <button class="btn btn-warning btn-sm" type="button"
                (click)="cancel()">Cancel</button>
      </div>
    </div>
}
  </div>
</div>
